export default "__VITE_ASSET__D655MUpp__"